export function selectSavedPage(pages, requested, socialPageId) {
  return pages.find(page => page.id === requested)
    || (requested === 'social' && pages.find(page => page.id === socialPageId))
    || pages.find(page => page.name.toLowerCase() === requested?.toLowerCase())
    || pages[0] || null;
}
